import React, { useContext } from 'react';

import AppContext from '../context';

const StepNavigation = () => {
  const context = useContext(AppContext);

  const changeStep = step => {
    context.setStep(step);
  }

  return (
    <ul className="step-navigation">
      <li className={context.step === 1 ? 'active' : ''}>
        <a onClick={changeStep.bind(this, 1)}>
          <span className="step-number">1</span>
          <span className="step-name">Select Type</span>
          {context.filters.group ?
            <img src={`/assets/icon_${context.filters.group.toLowerCase()}.svg`} />
          : null}
        </a>
      </li>

      {context.progress > 1 && context.filters.group === 'Individual' ?
        <li className={`four-steps ${context.step === 2 ? 'active' : ''}`}>
          <a className="step-back" onClick={changeStep.bind(this, 1)}>
            {context.filters.group ?
              <img src={`/assets/icon_${context.filters.group.toLowerCase()}.svg`}/>
            : null}
          </a>
          <a onClick={changeStep.bind(this, 2)}>
            <span className="step-number">2</span>
            <span className="step-name">Select Grade</span>
            <span className="selected-number">{ context.filters.grade }</span>
          </a>
        </li>
      : null}

      {context.progress > 1 && context.filters.group === 'Family' ?
        <li className={context.step === 2 ? 'active' : ''}>
          <a className="step-back" onClick={changeStep.bind(this, 1)}>
            {context.filters.group ?
              <img src={`/assets/icon_${context.filters.group.toLowerCase()}.svg`}/>
            : null}
          </a>
          <a onClick={changeStep.bind(this, 2)}>
            <span className="step-number">2</span>
            <span className="step-name">Select Family Member</span>
            {context.filters.family ?
              <img src={`/assets/icon_${context.filters.family.toLowerCase()}.svg`}/>
            : null}
          </a>
        </li>
      : null}

      {context.progress > 1 && context.filters.group === 'Group' ?
        <li className={context.step === 2 ? 'active' : ''}>
          <a className="step-back" onClick={changeStep.bind(this, 1)}>
            {context.filters.group ?
              <img src={`/assets/icon_${context.filters.group.toLowerCase()}.svg`}/>
            : null}
          </a>
          <a onClick={changeStep.bind(this, 2)}>
            <span className="step-number">2</span>
            <span className="step-name">Select Group Type</span>
            {context.filters.group_type ?
              <img src={`/assets/icon_${context.filters.group_type.toLowerCase()}.svg`}/>
            : null}
          </a>
        </li>
      : null}

      {context.progress > 2 && context.filters.group === 'Individual' ?
        <li className={`four-steps ${context.step === 3 ? 'active' : ''}`}>
          <a className="step-back" onClick={changeStep.bind(this, 2)}>
            <span className="selected-number">{ context.filters.grade }</span>
          </a>
          <a onClick={changeStep.bind(this, 3)}>
            <span className="step-number">3</span>
            <span className="step-name">Select Gender</span>
            {context.filters.gender ?
              <img src={`/assets/icon_${context.filters.gender.toLowerCase()}.svg`}/>
            : null}
          </a>
        </li>
      : null}

      {context.progress === 4 ?
        <li className={`${context.step === 4 ? 'active' : ''} ${context.filters.group === 'Individual' ? 'four-steps' : ''}`}>
          {context.filters.group === 'Individual' ?
            <a className="step-back" onClick={changeStep.bind(this, 3)}>
              {context.filters.gender ?
                <img src={`/assets/icon_${context.filters.gender.toLowerCase()}.svg`}/>
              : null}
            </a>
          : null}

          {context.filters.group === 'Family' ?
            <a className="step-back" onClick={changeStep.bind(this, 2)}>
              {context.filters.family ?
                <img src={`/assets/icon_${context.filters.family.toLowerCase()}.svg`}/>
              : null}
            </a>
          : null}

          {context.filters.group === 'Group' ?
            <a className="step-back" onClick={changeStep.bind(this, 2)}>
              {context.filters.group_type ?
                <img src={`/assets/icon_${context.filters.group_type.toLowerCase()}.svg`}/>
              : null}
            </a>
          : null}

          <a onClick={changeStep.bind(this, 4)}>
            <span className="step-number">
              <span>{context.filters.group === 'Individual' ? 4 : 3}</span>
            </span>
            <span className="step-name">Results</span>
          </a>
        </li>
      : null}
    </ul>
  );
}

export default StepNavigation;